/** Path for the interior designer "My Designs" page (tabs use URL hash). */
export const INTERIOR_DESIGNER_DESIGNS_PATH = '/interior-designer/designs';

const CANONICAL_HASHES = new Set(['iterations', 'featured', 'portfolio']);

/**
 * @param {string} [hash] — `location.hash` (includes `#`) or raw fragment
 * @returns {'iterations' | 'featured' | 'portfolio'}
 */
export function parseDesignsTabFromHash(hash) {
  const raw = (hash || '').replace(/^#/, '').trim().toLowerCase();
  if (raw === 'featured') return 'featured';
  if (raw === 'portfolio') return 'portfolio';
  if (raw === 'iterations') return 'iterations';
  return 'iterations';
}

/**
 * @param {'iterations' | 'featured' | 'portfolio'} tab
 * @returns {string} pathname + hash for react-router `navigate()`
 */
export function designsHrefWithTab(tab) {
  const t = CANONICAL_HASHES.has(tab) ? tab : 'iterations';
  return `${INTERIOR_DESIGNER_DESIGNS_PATH}#${t}`;
}

/** Return URL after add/edit portfolio wizard (Portfolio tab selected). */
export function designsPortfolioReturnHref() {
  return designsHrefWithTab('portfolio');
}
